export default {"src":"/_next/static/media/talk-it-out.bc9315a1.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};